<div class="minimal-modal-wrapper p-4 text-center">
    <button type="button" class="btn-close-minimal" (click)="activeModal.dismiss('cancel')" aria-label="Close">
        <span class="material-symbols-outlined">close</span>
    </button>

    <div class="icon-container mb-3">
        <div class="icon-shape warning-shape">
            <span class="material-symbols-outlined">
                @if (hashConflict) { file_copy } @else { warning }
            </span>
        </div>
    </div>

    <h3 class="modal-title-clean">
        @if (hashConflict && !pathConflict) {
            File Identici Rilevati
        } @else if (pathConflict && !hashConflict){
            File Esistenti Rilevati
        } @else {
            Sono stati rilevati dei conflitti
        }
    </h3>
    
    <p class="modal-text mb-3">
         @if (hashConflict && !pathConflict) {
            Sono stati rilevati <strong>{{ hashDuplicatesList.length }}</strong> file con <strong>contenuto identico</strong> a documenti già processati nel sistema.
         }  @else if (pathConflict && !hashConflict){
            Sono stati rilevati <strong>{{ pathDuplicatesList.length }}</strong> file con lo stesso percorso di documenti già esistenti.
         }
         @else {
            Sono stati rilevati <strong>{{ hashDuplicatesList.length }}</strong> file con <strong>contenuto identico</strong> a documenti già processati nel sistema e <strong>{{ pathDuplicatesList.length }}</strong> file con lo stesso percorso di documenti già esistenti.
         
         }
    </p>
    @if(hashConflict){
        <p class="modal-text mb-3">Files identici:</p>
    <div class="duplicates-scroll-area text-start mb-4">
        @for (hashconflict of hashDuplicatesList; track hashconflict.incomingFile) {
            <div class="duplicate-item">
                <span class="material-symbols-outlined file-icon">description</span>
                <div class="file-info w-100">
                    <span class="file-name">{{ getFileName(hashconflict.incomingFile) }}</span>
                    <span class="file-path mb-1">{{ hashconflict.incomingFile }}</span>
                        <div class="mt-2 p-2 rounded" style="background-color: #fffbeb; border: 1px solid #fde68a;">
                            <div class="d-flex align-items-center gap-1 mb-1">
                                <span class="material-symbols-outlined" style="font-size: 16px; color: #d97706;">info</span>
                                <span style="font-size: 0.8rem; font-weight: 600; color: #d97706;">File identico esistente:</span>
                            </div>
                            <span class="file-name d-block" style="font-size: 0.85rem; color: #92400e;">
                                {{ getFileName(hashconflict.existingFile) }}
                            </span>
                            <span class="file-path d-block" style="font-size: 0.75rem; color: #b45309;">
                                {{ hashconflict.existingFile }}
                            </span>
                        </div>
                </div>
            </div>
        }
    </div>
    }
    @if(pathConflict){
        <p class="modal-text mb-3">Files con lo stesso percorso:</p>
        <div class="duplicates-scroll-area text-start mb-4">
        @for (pathconflict of pathDuplicatesList; track pathconflict.incomingFile) {
            <div class="duplicate-item">
                <span class="material-symbols-outlined file-icon">description</span>
                <div class="file-info w-100">
                    <span class="file-name">{{ getFileName(pathconflict.incomingFile) }}</span>
                    <span class="file-path mb-1">{{ pathconflict.incomingFile }}</span>
                </div>
            </div>
        }
        </div>
    }
      

    <div class="action-selector text-start mb-4">
        <label for="duplicateAction" class="form-label fw-bold mb-2" style="color: #334155; font-size: 0.95rem;">
            Come vuoi procedere?
        </label>
        <select id="duplicateAction" class="form-select custom-select shadow-sm" [(ngModel)]="selectedAction">
            
            @if (!allDuplicates) {
                <option value="ignore">Ignora questi file (processa solo i nuovi documenti)</option>
            }
            
            @if (hashConflict) {
                <option value="replace">Sostituisci (elimina i file precedenti e tieni questi nei nuovi percorsi)</option>
            } @else {
                <option value="replace">Aggiorna versione (sovrascrivi i file esistenti con i nuovi)</option>
            }
            
            @if (canKeepBoth) {
                <option value="keep">Mantieni entrambi (rinomina automaticamente i nuovi file)</option>
            }
        </select>
    </div>

    <div class="modal-actions d-flex justify-content-center gap-3">
        <button type="button" class="btn-action btn-cancel" (click)="activeModal.dismiss('cancel')">
            Annulla
        </button>
        <button type="button" class="btn-action btn-confirm" (click)="confirm()">
            Conferma operazione
        </button>
    </div>
</div>